// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/user/user.proto (package carmen, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_proto_model_core_annotations } from "../core/annotations_pb";
import { file_proto_model_core_associations } from "../core/associations_pb";
import { file_proto_model_core_permissions } from "../core/permissions_pb";
import { file_proto_model_preferences_preferences } from "../preferences/preferences_pb";
import { file_proto_model_trip_trip } from "../trip/trip_pb";

/**
 * Describes the file proto/model/user/user.proto.
 */
export const file_proto_model_user_user = /*@__PURE__*/
  fileDesc("Chtwcm90by9tb2RlbC91c2VyL3VzZXIucHJvdG8SBmNhcm1lbiLZAgoEVXNlchIPCgd1c2VyX2lkGAEgASgJEhQKDGRpc3BsYXlfbmFtZRgCIAEoCRINCgVlbWFpbBgDIAEoCRIrCgdjcmVhdGVkGAQgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIsCghtb2RpZmllZBgFIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASEwoLdHJhdmVsZXJfaWQYBiABKAkSLAoLcHJlZmVyZW5jZXMYByABKAsyEy5jYXJtZW4uUHJlZmVyZW5jZXNCAhgBEi4KC3Blcm1pc3Npb25zGAggASgLMhMuY2FybWVuLlBlcm1pc3Npb25zQgSItRgCEiEKBXRyaXBzGAkgAygLMgwuY2FybWVuLlRyaXBCBIi1GAESKgoMYXNzb2NpYXRpb25zGAogASgLMhQuY2FybWVuLkFzc29jaWF0aW9uc0IoWiZnaXRodWIuY29tL3l1bmFjYWJhL2Nhcm1lbi9wcm90by9tb2RlbGIGcHJvdG8z", [file_google_protobuf_timestamp, file_proto_model_core_annotations, file_proto_model_core_associations, file_proto_model_core_permissions, file_proto_model_preferences_preferences, file_proto_model_trip_trip]);

/**
 * Describes the message carmen.User.
 * Use `create(UserSchema)` to create a new message.
 */
export const UserSchema = /*@__PURE__*/
  messageDesc(file_proto_model_user_user, 0);

